import { render, staticRenderFns } from "./VipForm.vue?vue&type=template&id=7f62d9b5&scoped=true&"
import script from "./VipForm.vue?vue&type=script&lang=js&"
export * from "./VipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f62d9b5",
  null
  
)

export default component.exports